export default [
 { title: 'Actualizaciones', to: '#!' },
 { title: 'Precios', to: '#!' },

 { title: 'Networking', to: '#!' },
 { title: 'Empleos', to: '#!' },

 { title: 'Marketing', to: '#!' },

 { title: 'Agencias', to: '#!' },
 { title: 'Agentes', to: '#!' },
 { title: 'Documentacion', to: '#!' }
];
